(function () {
  'use strict';

  if (window.KuKirinBuyNowLoaded) return;
  window.KuKirinBuyNowLoaded = true;

  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  var BUTTON_SELECTOR = '[data-km-buy-now]';
  var ATC_SELECTOR = '[data-atc-form], button[type="submit"][name="add"]';
  var CART_SNAPSHOT_KEY = 'km_buy_now_cart_snapshot_v2';
  var CART_SNAPSHOT_MAX_AGE = 6 * 60 * 60 * 1000;
  var restorePromise = null;

  function getAtcButton(form) {
    return form ? form.querySelector(ATC_SELECTOR) : null;
  }

  function isUnavailable(form) {
    var atc = getAtcButton(form);
    if (!atc) return true;
    return atc.disabled || atc.getAttribute('aria-disabled') === 'true';
  }

  function syncForm(form) {
    if (!form) return;
    var buyNow = form.querySelector(BUTTON_SELECTOR);
    if (!buyNow || buyNow.getAttribute('aria-busy') === 'true') return;

    var unavailable = isUnavailable(form);
    buyNow.disabled = unavailable;
    buyNow.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
  }

  function observeForm(form) {
    if (!form || form.dataset.kmBuyNowObserved === 'true') return;
    var buyNow = form.querySelector(BUTTON_SELECTOR);
    var atc = getAtcButton(form);
    if (!buyNow || !atc) return;

    form.dataset.kmBuyNowObserved = 'true';
    syncForm(form);

    var observer = new MutationObserver(function () {
      syncForm(form);
    });

    observer.observe(atc, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });
  }

  function init(scope) {
    scope = scope || document;

    if (scope.matches && scope.matches(FORM_SELECTOR)) {
      observeForm(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(FORM_SELECTOR).forEach(observeForm);
    }
  }

  function setBusy(button, busy) {
    var label = button.querySelector('.t4s-km-buy-now__text');

    if (!button.dataset.kmOriginalLabel && label) {
      button.dataset.kmOriginalLabel = label.textContent;
    }

    if (busy) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = button.dataset.kmProcessingLabel || button.dataset.kmOriginalLabel || '';
    } else {
      button.removeAttribute('aria-busy');
      if (label && button.dataset.kmOriginalLabel) {
        label.textContent = button.dataset.kmOriginalLabel;
      }
      syncForm(button.closest(FORM_SELECTOR));
    }
  }

  function resetBusyButtons() {
    document.querySelectorAll(BUTTON_SELECTOR + '[aria-busy="true"]').forEach(function (button) {
      setBusy(button, false);
    });
  }

  function showError(message) {
    var text = message || 'Unable to start checkout. Please try again.';

    if (window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') {
      window.T4SThemeSP.Notices(text, 'warning');
      return;
    }

    window.alert(text);
  }

  function encodeBase64UrlUtf8(value) {
    var bytes = new TextEncoder().encode(value);
    var binary = '';
    bytes.forEach(function (byte) { binary += String.fromCharCode(byte); });
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
  }

  function getLineItemProperties(formData) {
    var properties = {};

    formData.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (!match) return;
      if (typeof value !== 'string' || value === '') return;
      properties[match[1]] = value;
    });

    return properties;
  }

  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';
    return root;
  }

  async function fetchCart() {
    var response = await fetch(getRoot() + 'cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store',
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('Unable to read the current cart.');
    return response.json();
  }

  function cartItemForRestore(item) {
    var restored = {
      id: item.variant_id || item.id,
      quantity: item.quantity
    };

    if (item.properties && Object.keys(item.properties).length) {
      restored.properties = item.properties;
    }

    if (item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan &&
        item.selling_plan_allocation.selling_plan.id) {
      restored.selling_plan = item.selling_plan_allocation.selling_plan.id;
    }

    return restored;
  }

  async function saveOriginalCart() {
    var cart = await fetchCart();
    var snapshot = {
      createdAt: Date.now(),
      items: (cart.items || []).map(cartItemForRestore),
      note: cart.note || '',
      attributes: cart.attributes || {}
    };

    try {
      sessionStorage.setItem(CART_SNAPSHOT_KEY, JSON.stringify(snapshot));
    } catch (error) {
      throw new Error('Unable to preserve your cart before checkout. Please try again.');
    }

    return snapshot;
  }

  function readCartSnapshot() {
    var raw;
    try {
      raw = sessionStorage.getItem(CART_SNAPSHOT_KEY);
    } catch (error) {
      return null;
    }
    if (!raw) return null;

    try {
      var snapshot = JSON.parse(raw);
      if (!snapshot || !snapshot.createdAt || Date.now() - snapshot.createdAt > CART_SNAPSHOT_MAX_AGE) {
        sessionStorage.removeItem(CART_SNAPSHOT_KEY);
        return null;
      }
      if (!Array.isArray(snapshot.items)) snapshot.items = [];
      if (!snapshot.attributes || typeof snapshot.attributes !== 'object') snapshot.attributes = {};
      return snapshot;
    } catch (error) {
      try { sessionStorage.removeItem(CART_SNAPSHOT_KEY); } catch (ignore) {}
      return null;
    }
  }

  function clearCartSnapshot() {
    try { sessionStorage.removeItem(CART_SNAPSHOT_KEY); } catch (ignore) {}
  }

  function updateCartCountUi(cart) {
    var count = Number(cart && cart.item_count) || 0;

    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = String(count);
      if (count > 0) node.classList.remove('t4s-op-0');
      else node.classList.add('t4s-op-0');
    });

    var html = document.documentElement;
    Array.from(html.classList).forEach(function (className) {
      if (/^t4s-cart-count-\d+$/.test(className)) html.classList.remove(className);
    });
    html.classList.add('t4s-cart-count-' + count);

    document.dispatchEvent(new CustomEvent('cart:update:count', {
      detail: { count: count },
      bubbles: true,
      cancelable: false
    }));

    /* Ask Kalles to re-render the mini cart, prices and shipping state too. */
    document.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      cancelable: false
    }));
  }

  function stableProperties(properties) {
    var source = properties && typeof properties === 'object' ? properties : {};
    var result = {};
    Object.keys(source).sort().forEach(function (key) {
      if (source[key] !== null && source[key] !== '') result[key] = String(source[key]);
    });
    return result;
  }

  function restoreSignature(item) {
    var variantId = item.variant_id || item.id || '';
    var sellingPlan = item.selling_plan ||
      (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id) || '';
    return JSON.stringify([
      String(variantId),
      String(sellingPlan || ''),
      stableProperties(item.properties)
    ]);
  }

  async function restoreOriginalCartIfNeeded() {
    var snapshot = readCartSnapshot();
    if (!snapshot) return null;
    if (restorePromise) return restorePromise;

    restorePromise = (async function () {
      var root = getRoot();
      var currentCart = await fetchCart();
      var desired = new Map();
      var currentBySignature = new Map();

      snapshot.items.forEach(function (item) {
        desired.set(restoreSignature(item), item);
      });

      (currentCart.items || []).forEach(function (item) {
        var signature = restoreSignature(item);
        if (!currentBySignature.has(signature)) currentBySignature.set(signature, []);
        currentBySignature.get(signature).push(item);
      });

      var missingItems = [];
      desired.forEach(function (item, signature) {
        if (!currentBySignature.has(signature)) missingItems.push(item);
      });

      /* Add missing original lines before removing anything from the current cart. */
      if (missingItems.length) {
        var addResponse = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: missingItems }),
          credentials: 'same-origin'
        });
        if (!addResponse.ok) throw new Error('Unable to restore the previous cart.');
        currentCart = await fetchCart();
      }

      var updates = {};
      var matched = new Set();

      (currentCart.items || []).forEach(function (item) {
        var signature = restoreSignature(item);
        var wanted = desired.get(signature);

        if (!wanted || matched.has(signature)) {
          updates[item.key] = 0;
          return;
        }

        matched.add(signature);
        updates[item.key] = wanted.quantity;
      });

      var updateResponse = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          updates: updates,
          note: snapshot.note || '',
          attributes: snapshot.attributes || {}
        }),
        credentials: 'same-origin'
      });
      if (!updateResponse.ok) throw new Error('Unable to restore the previous cart.');

      var restoredCart = await fetchCart();
      var restoredCounts = new Map();
      (restoredCart.items || []).forEach(function (item) {
        restoredCounts.set(restoreSignature(item), item.quantity);
      });

      var verified = restoredCart.items.length === snapshot.items.length;
      if (verified) {
        snapshot.items.forEach(function (item) {
          if (restoredCounts.get(restoreSignature(item)) !== item.quantity) verified = false;
        });
      }
      if (!verified) throw new Error('The previous cart could not be fully restored.');

      clearCartSnapshot();
      updateCartCountUi(restoredCart);
      return restoredCart;
    })().catch(function (error) {
      console.error('[KuKirin Buy Now] Cart restore failed:', error);
      return null;
    }).finally(function () {
      restorePromise = null;
    });

    return restorePromise;
  }

  async function handleBuyNow(button) {
    var form = button.closest(FORM_SELECTOR);
    if (!form || button.getAttribute('aria-busy') === 'true') return;

    if (isUnavailable(form)) {
      syncForm(form);
      return;
    }

    if (typeof form.reportValidity === 'function' && !form.reportValidity()) return;

    var formData = new FormData(form);
    var variantId = String(formData.get('id') || '').replace(/\D/g, '');
    if (!variantId) {
      showError('Please select an available option before checkout.');
      return;
    }

    var quantity = parseInt(formData.get('quantity'), 10);
    if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

    setBusy(button, true);

    try {
      var root = getRoot();

      /*
       * A Shopify cart permalink creates a temporary checkout cart. Before we
       * use it, preserve the shopper's real storefront cart so returning from
       * checkout does not replace an existing 3/5/etc-item cart with quantity 1.
       */
      await saveOriginalCart();

      var checkoutUrl = root + 'cart/' + variantId + ':' + quantity;
      var properties = getLineItemProperties(formData);

      if (Object.keys(properties).length) {
        checkoutUrl += '?properties=' + encodeURIComponent(
          encodeBase64UrlUtf8(JSON.stringify(properties))
        );
      }

      window.location.assign(checkoutUrl);
    } catch (error) {
      setBusy(button, false);
      showError(error && error.message);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest(BUTTON_SELECTOR) : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    handleBuyNow(button);
  });

  document.addEventListener('change', function (event) {
    var form = event.target.closest ? event.target.closest(FORM_SELECTOR) : null;
    if (!form) return;
    window.setTimeout(function () { syncForm(form); }, 0);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
    restoreOriginalCartIfNeeded();
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  /* Safari/Chrome can restore a product page from the back-forward cache.
     Always clear the temporary Redirecting… state when the page is left/restored. */
  window.addEventListener('pagehide', function () {
    resetBusyButtons();
  });

  window.addEventListener('pageshow', function () {
    resetBusyButtons();
    init(document);
    restoreOriginalCartIfNeeded();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      resetBusyButtons();
      init(document);
      restoreOriginalCartIfNeeded();
    }
  });

  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('variant:changed.kmBuyNow', function (event) {
      var target = event.target;
      if (!target) return;

      if (target.matches && target.matches(FORM_SELECTOR)) {
        syncForm(target);
      } else if (target.querySelectorAll) {
        target.querySelectorAll(FORM_SELECTOR).forEach(syncForm);
      }
    });
  }

  init(document);
  restoreOriginalCartIfNeeded();
})();
